import { render, staticRenderFns } from "./public-organization-booking-custom-form.vue?vue&type=template&id=8d65bb08&scoped=true&"
import script from "./public-organization-booking-custom-form.vue?vue&type=script&lang=ts&"
export * from "./public-organization-booking-custom-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d65bb08",
  null
  
)

export default component.exports